function loadMoreProducts() {
  $('button.load-more_btn.btn').attr('disabled',true);
 var products_on_page = $(".products-on-page");
var next_url = $('#Huratips-Pagination a').attr("href");
    // var paramString = next_url.split('?')[1];
    //   var pagenext_url=paramString.replace('page','cpage');
 if(next_url!='' && next_url != 'undefined'){  
var load_more_btn = $(".load-more_btn ");
var load_more_spinner = $(".load-more_spinner");
  $.ajax({
    url: next_url,
    type: "GET",
    dataType: "html",
    beforeSend: function () {
      load_more_btn.hide();
      load_more_spinner.show();
    },
  }).done(function (next_page) {
    load_more_spinner.hide();
   var new_products = $(next_page).find(".products-on-page");
    var new_url = $(next_page).find('#Huratips-Pagination a').attr("href");
     $('#Huratips-Pagination a').attr("href",new_url);
     $('.pagination_number').attr("next-url");
    if (new_url) load_more_btn.show();
    products_on_page.append(new_products.html());
   $('button.load-more_btn.btn').attr('disabled',false);
    // window.history.replaceState({ }, '', `https://www.westcoastwalls.ca/collections/for-kids-wallpaper?${pagenext_url}`);
  });
 }
}
function isInView(elem){
    console.log($(elem).offset().top - $(window).scrollTop())
   return $(elem).offset().top - $(window).scrollTop() < 800 && $(elem).offset().top - $(window).scrollTop() >0;
    
}
$(window).scroll(function(){
   if(isInView($('.load-more .load-more_btn')) ==  true){
       
       $('.load-more .load-more_btn').trigger('click');
   }
})



